<template>
    <div class="relatorio-analitico">
        <RelatorioAnaliticoComponentList
            app_modulo="promotor"
            app_submodulo="relatorio-analitico"
            app_tela="relatorio-lps-nao-visita"
            :objectList="lpsNaoVisitaList"
            :objectListAll="lpsNaoVisitaListAll"
            :isEmpty="isEmpty"
            :isLoading="isLoading"
            :isDataStarted="isDataStarted"
            :pagination="pagination"
            :tooltipLabelSearch="
                $t('msg-campo-busca-n', {
                    n: `${$t('codigo')}, ${$t('rsocial')} e ${$t('nome')} (${$t('cliente')} e ${$t('lps')})`,
                })
            "
            showLateralFilter
            :cameFrom="cameFrom"
            @filtersReset="filtersReset = $event"
            @loadedFiels="loadedFiels = $event"
            @carregarDados="carregarDados($event)"
            @carregarDadosExportAll="carregarDados($event, true)"
            @search="onSearch($event)"
            @clearFilter="clearFilter()"
            @orderColumn="pagination.orderColumn = $event"
            @orderDirection="pagination.orderDirection = $event"
            @perPage="pagination.perPage = $event"
            @currentPage="pagination.currentPage = $event"
            @isLoading="isLoading = $event"
            @voltar="$emit('voltar', $event)"
        >
            <template v-slot:top-filter>
                <vss-select
                    title="colaborador"
                    ref="colaboradorSelect"
                    class="smaller"
                    :value="colaboradorSelected"
                    :options="colaboradorList"
                    :height="40"
                    :loading="colaboradorLoading"
                    @search="carregarColaboradores"
                    @input="updateColaborador"
                    label="nome"
                    :closeOnSelect="false"
                    no-clearfix
                    multiple
                    clearable
                    searchable
                    tooltipLabel="msg-associacao-empresa-colaborador"
                >
                    <template #multiple-selected="{ selected }">
                        ({{ selected && selected.length > 0 ? selected.length : $t('todos') }})
                    </template>
                </vss-select>
            </template>

            <template v-slot:table-column="{ props, field }">
                <div 
                    v-if="field.key === 'resultado'"
                    :class="{ 
                        'is-text-color-success': props.row.resultadoNumerico > 0,
                        'is-text-color-danger': props.row.resultadoNumerico < 0
                    }"
                >
                    {{ isNull(props.row[field.key]) ? '---' : props.row[field.key] }}
                </div>
                <div v-else>
                    {{ isNull(props.row[field.key]) ? '---' : props.row[field.key] }}
                </div>
            </template>

            <template v-slot:lateral-filter>
                <RelatorioLpsNaoVisitaListFiltro
                    ref="filtroRef"
                    :filtersReset="filtersReset"
                    @update-filtro="updateFiltro"
                />
            </template>
        </RelatorioAnaliticoComponentList>
    </div>
</template>

<script>
import RelatorioAnaliticoComponentList from '@/components/shared/tela/RelatorioAnaliticoComponentList.vue';
import RelatorioLpsNaoVisitaListFiltro from '@/components/promotor/relatorio-analitico/relatorio-lps-nao-visita/RelatorioLpsNaoVisitaListFiltro.vue';
import LateralContentFoto from '@/components/shared/tela/LateralContentFoto.vue';

export default {
    components: {
        RelatorioAnaliticoComponentList,
        RelatorioLpsNaoVisitaListFiltro,
        LateralContentFoto
    },
    props: {
        cameFrom: {
            type: String,
            default: 'route',
        },
        idFrom: {
            type: Number,
            default: 0,
        },
        reloadData: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            lpsNaoVisitaList: [],
            lpsNaoVisitaListAll: [],

            filtros: {
                idColaboradorList: [],
                dataInicial: new Date(this.$moment().subtract(30, 'days')),
                dataFinal: new Date(),
                idClienteList: [],
                idLpsList: [],
                diasSemVisita: 0,
                nuncaVisitado: false,
            },

            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
                orderColumn: 'idlpserp',
                orderDirection: 'asc',
                queryFilter: '.*',
            },

            empresaList: [],
            empresaSelected: [],
            empresaLoading: false,

            colaboradorList: [],
            colaboradorSelected: [],
            colaboradorLoading: false,

            isLoading: false,
            loadedFiels: false,

            isEmpty: true,
            filtersReset: false,

            isDataStarted: false,
        };
    },
    watch: {
        reloadData(val) {
            if (val) this.carregarDados(this.pagination.currentPage);
        },
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];
    },
    methods: {
        onSearch(value) {
            this.pagination.queryFilter = value;
            this.carregarDados();
        },
        carregarDados(currentPage = 1, getAll = false) {
            if (!getAll && currentPage == 1 && this.pagination.currentPage != 1) {
                this.pagination.resetPagination = true;
            }

            if (!getAll) this.lpsNaoVisitaListAll = [];

            this.isLoading = true;
            this.$axios
                .post(`/pro/relatorio/lpsnaoatendimento/list.json`, this.filtros, {
                    params: {
                        column: this.pagination.orderColumn,
                        order: this.pagination.orderDirection,
                        page: currentPage - 1,
                        limit: getAll ? this.pagination.totalRows : this.pagination.perPage,
                        search: this.pagination.queryFilter,
                    },
                })
                .then((response) => {
                    if (!getAll) {
                        this.isEmpty = response.data.totalElements == 0;
                        this.pagination.totalRows = response.data.totalElements;
                    }

                    return response.data.content.map((obj) => {
                        return {
                            ...obj,
                            id: obj.codigo + '-' + obj.cliente_codigo,
                            cod_lps: obj.codigo,
                            cliente_nome: obj.cliente,
                            cliente_situacao:
                                obj.cliente_situacao === 3 ? this.$t('ativo') : this.$t('inativo'),
                            lps_situacao: obj.lps_situacao === 3 ? this.$t('ativo') : this.$t('inativo'),
                            data_execucao: this.$moment(obj.data_execucao).format('L'),
                            valor_custo: !this.isNull(obj.valor_custo) ? this.parseAsCurrency(obj.valor_custo) : obj.valor_custo,
                            valor_cobrado: !this.isNull(obj.valor_cobrado) ? this.parseAsCurrency(obj.valor_cobrado) : obj.valor_cobrado,
                            resultado: !this.isNull(obj.resultado) ? this.parseAsCurrency(obj.resultado) : obj.resultado,
                            resultadoNumerico: obj.resultado,
                            dias_sem_visita: obj.data_sem_visita,
                            data_ultima_visita: this.isNull(obj.data_ultima_visita) ? '---' : this.$moment(obj.data_ultima_visita).format('L'),
                        };
                    });
                })
                .then((mappedContent) => {
                    if (getAll) {
                        this.lpsNaoVisitaListAll = mappedContent;
                    } else {
                        this.lpsNaoVisitaList = mappedContent;
                    }
                })
                .catch((exception) => {
                    console.error('Erro ao carregar faturamento.', exception);
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-dados-geral');
                })
                .finally((_) => {
                    this.pagination.resetPagination = false;
                    this.isDataStarted = true;
                    if (this.loadedFiels) this.isLoading = false;
                });
        },
        carregarEmpresas(search = '') {
            this.empresaLoading = true;
            this.$axios
                .get(`/vendas/empresa/list.json?param=${search}`)
                .then((response) => {
                    if (response.status != 200) {
                        console.error(`[FATURAMENTO] Erro status ${r.status} ao carregar empresas.`);
                        console.error(`[FATURAMENTO] Mensagem: ${r.message}`);
                    } else {
                        this.empresaList = response.data.content.map((e) => {
                            return {
                                id: e.idempresa,
                                rsocial: e.rsocial,
                            };
                        });
                    }
                })
                .catch((e) => {
                    this.empresaList = [];
                    console.error('[FATURAMENTO] Erro ao carregar empresas.', e);
                })
                .finally((_) => {
                    this.empresaLoading = false;
                });
        },
        updateEmpresa(empresa) {
            this.empresaSelected = empresa;

            this.colaboradorSelected = [];
            this.colaboradorList = [];

            this.filtros.idEmpresaList =
                this.empresaSelected.length == 0 ? [] : this.empresaSelected.map((e) => e.id);

            this.carregarColaboradores('');
            this.carregarDados();
        },
        carregarColaboradores(search = '') {
            this.colaboradorLoading = true;

            const empresa =
                this.empresaSelected.length > 0 ? this.empresaSelected.map((e) => e.id) : [];

            this.$axios
                .post(`/employees/list/associacaoidsempresa.json?search=${search}`, empresa)
                .then((response) => {
                    if (response.status != 200) {
                        console.error(
                            `[FATURAMENTO] Erro status ${r.status} ao carregar colaboradores.`
                        );
                        console.error(`[FATURAMENTO] Mensagem: ${r.message}`);
                    } else {
                        this.colaboradorList = response.data.content;
                    }
                })
                .catch((e) => {
                    this.empresaList = [];
                    console.error('[FATURAMENTO] Erro ao carregar colaboradores.', e);
                })
                .finally((f) => {
                    this.colaboradorLoading = false;
                });
        },
        updateColaborador(colaborador) {
            this.colaboradorSelected = colaborador;

            this.filtros.idColaboradorList =
                this.colaboradorSelected.length == 0
                    ? []
                    : this.colaboradorSelected.map((e) => e.id);

            this.carregarDados();
        },
        clearFilter() {
            this.pagination.queryFilter = '.*';
            
            this.filtros.idEmpresaList = [];
            this.empresaSelected = [];

            this.filtros.idColaboradorList = [];
            this.colaboradorSelected = [];

            this.filtros.dataInicial = new Date(this.$moment().subtract(30, 'days'));
            this.filtros.dataFinal = new Date();
            this.filtros.idClienteList = [];
            this.filtros.idLpsList = [];
            this.filtros.diasSemVisita = 0;
            this.filtros.nuncaVisitado = false;

            setTimeout(() => {
                this.carregarDados();
            }, 1000);
        },
        updateFiltro(filtro) {
            this.filtros[filtro.nomeFiltro] = filtro.valor;
        },
    },
};
</script>

<style lang="scss" scoped>
.relatorio-analitico {
    height: 100%;
}
</style>